import {
  Button,
  DatePicker,
  Divider,
  Input,
  message,
  Select,
  Space,
  Spin,
  Tooltip,
} from "antd";
import { useEffect, useState } from "react";
import { ConditionalRenderer } from "components";
import {
  AccordianDropdownArrow,
  AiIcon,
  AlertWhiteIcon,
  CalenderIcon,
  ManualIcon,
  UpdateBTnIcon,
  UploadIcon,
} from "icons";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import { useParams } from "react-router-dom";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { useCurrentUserContext } from "providers";
import styles from "./styles.module.scss";
import { SingleInput } from "../singleInput";
import moment from "moment";
// import { ReminderHistoryTable } from "./reminderHistoryTable";
import { Collapse } from "antd";
import { DownOutlined, PlusOutlined, RightOutlined } from "@ant-design/icons";
import { ReactComponent as DropdownArrow } from "icons/dropdownArrow.svg";
import { InputWithLabel } from "./childInputField";
import { childKeys, formFields } from "pages/cases-detail/constants";
import { ParentInputField } from "./parentInputField";
import { PrefixInsideInput } from "./prefixInsideInput";
import { useRecoilState } from "recoil";
import { caseStatus } from "store/atom";
import { ExcelViewer } from "pages/excel-file";

export const SingleFormItemDetail = ({
  caseItemData,
  item,
  totalFormData,
  setTotalFormData,
  handleUpdateCase,
  dropdownsListObj,
  refetchDropdownsListObj,
  updateCaseLoading,
  caseHistoryUpdateLoading,
  refetchDetail,
  setIsExcelFileChanged,
  isExcelFileChanged,
  // tableData,
}) => {
  const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

  const items = [
    {
      key: "1",
      label: "This is panel header 1",
      children: <p>{text}</p>,
    },
    {
      key: "2",
      label: "This is panel header 2",
      children: <p>{text}</p>,
    },
    {
      key: "3",
      label: "This is panel header 3",
      children: <p>{text}</p>,
    },
  ];

  const { user } = useCurrentUserContext();
  const { translator } = useLanguageTranslator();
  const reminderTrans = translator("caseDetail.reminder");
  const { caseId } = useParams();
  const [email, setEmail] = useState();
  const [activeKey, setActiveKey] = useState(item?.id === 18 ? "2" : "1");
  const [caseStatusOpenOrClosed, setCaseStatusOpenOrClosed] =
    useRecoilState(caseStatus);

  const [reminder, { isLoading: reminderLoading }] = UseLazyApiCallV2({
    url: "/set_reminder",
    method: "POST",
  });

  const {
    data: caseHistory,

    isLoading: caseHistoryLoading,
    refetch: refetchFieldHistory,
  } = UseApiCallV2({
    url: "/get_case_history",
    method: "POST",
    skip: !caseId || !item?.key,
    paramsData: {
      case_id: caseId,
      fieldName: item?.key,
    },
  });
  const {
    data: reminderHistory,
    isLoading: reminderHistoryLoading,
    refetch: refetchReminderHistory,
  } = UseApiCallV2({
    url: "/get_email_reminders",
    method: "POST",
    skip: !caseId || !item?.key,
    paramsData: {
      case_id: caseId,
      fieldName: item?.key,
    },
  });

  const data = [
    {
      title: "After 1 day",
      key: "1d",
      keyForApi: "1d",
    },
    {
      title: "After 7 Days",
      key: "7d",
      keyForApi: "7d",
    },
    {
      title: "After 14 days",
      key: "14d",
      keyForApi: "14d",
    },
  ];

  const sections = [{ title: null, items: data?.slice(0, 3) }];

  const [activeOption, setActiveOption] = useState(data[0]);

  function handleSelectOption(item) {
    setActiveOption(item);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const regex = /^[A-Za-z0-9._%+-]+@smileautovermietung\.de$/;
    if (email && !regex.test(email)) {
      return message.error(translator("onlySmileEmailAllowed"));
    }
    const params = {
      email,
      key: caseItemData?.key,
      case_id: caseId,
      time: activeOption.key,
    };
    const allKeysPresent = Object.values(params)?.every((item) => !!item);
    if (!allKeysPresent) return message.error(translator("somethingWentWrong"));
    try {
      const reminderRes = await reminder({ params });
      if (reminderRes?.status === "SUCCESS") {
        message.success(translator("remiderSetSuccessMsg"));
        refetchReminderHistory();
        // handleCloseAlert();
      }
    } catch (error) {
      message.error(translator("somethingWentWrong"));
    }
  }

  const arr = [
    {
      Nr: 1,
      Datum: "Jun 01, 2025",
      Zeit: "14:38:24",
      Feld: "Klagebetrag in EUR",
      Früher: "€13000",
      Jetzt: "€15000",
      Aktualisiert: "Smiles- Max",
    },
    {
      Nr: 2,
      Datum: "Jun 01, 2025",
      Zeit: "14:38:24",
      Feld: "Klagebetrag in EUR",
      Früher: "€13000",
      Jetzt: "€15000",
      Aktualisiert: "Smiles- Max",
    },
    {
      Nr: 3,
      Datum: "Jun 01, 2025",
      Zeit: "14:38:24",
      Feld: "Klagebetrag in EUR",
      Früher: "€13000",
      Jetzt: "€15000",
      Aktualisiert: "Smiles- Max",
    },
    {
      Nr: 4,
      Datum: "Jun 01, 2025",
      Zeit: "14:38:24",
      Feld: "Klagebetrag in EUR",
      Früher: "€13000",
      Jetzt: "€15000",
      Aktualisiert: "Smiles- Max",
    },
    {
      Nr: 5,
      Datum: "Jun 01, 2025",
      Zeit: "14:38:24",
      Feld: "Klagebetrag in EUR",
      Früher: "€13000",
      Jetzt: "€15000",
      Aktualisiert: "Smiles- Max",
    },
    {
      Nr: 6,
      Datum: "Jun 01, 2025",
      Zeit: "14:38:24",
      Feld: "Klagebetrag in EUR",
      Früher: "€13000",
      Jetzt: "€15000",
      Aktualisiert: "Smiles- Max",
    },
  ];

  async function handleUpdateData(e) {
    e.preventDefault();
    await handleUpdateCase();
    refetchFieldHistory();
  }

  const twoHeadings =
    item?.key === "customerName" &&
    translator(`caseDetail.form.${item.key}`).split("+");

  return (
    <div className={styles.container}>
      <div className={styles.headingAndBtn}>
        <h3 className={styles.mainHeading}>
          {translator(`caseDetail.form.${item.key}`)}
        </h3>
      </div>
      <div className={styles.collapses}>
        <ConditionalRenderer condition={item.id === 18}>
          <Collapse
            activeKey={activeKey === "2" ? "2" : undefined}
            onChange={() => setActiveKey(activeKey === "2" ? null : "2")}
            expandIconPosition="end"
            expandIcon={({ isActive }) => (
              <AccordianDropdownArrow
                style={{
                  fontSize: "16px",
                  color: "#1890ff",
                  transform: isActive ? "rotate(0)" : "rotate(180deg)",
                }}
              />
            )}
          >
            <Collapse.Panel
              header={<h3> Arbeitsblatt </h3>}
              key="2"
              className={styles.secondCollapse}
            >
              <ConditionalRenderer condition={item.id === 18}>
                <ExcelViewer
                  fieldName={item.key}
                  refetchFieldHistory={refetchFieldHistory}
                  setIsExcelFileChanged={setIsExcelFileChanged}
                  isExcelFileChanged={isExcelFileChanged}
                  // tableData={tableData}
                />
              </ConditionalRenderer>
            </Collapse.Panel>
          </Collapse>
        </ConditionalRenderer>
        <Spin spinning={!!updateCaseLoading || !!caseHistoryUpdateLoading}>
          <Collapse
            activeKey={activeKey === "1" ? "1" : undefined}
            onChange={() => setActiveKey(activeKey === "1" ? null : "1")}
            expandIconPosition="end"
            expandIcon={({ isActive }) => (
              <AccordianDropdownArrow
                style={{
                  fontSize: "16px",
                  color: "#1890ff",
                  transform: isActive ? "rotate(0)" : "rotate(180deg)",
                }}
              />
            )}
          >
            <Collapse.Panel
              header={<h3>{translator("caseDetail.form.updates")}</h3>}
              key="1"
            >
              <ConditionalRenderer
                condition={!item?.isParent && item?.id !== 18}
              >
                <form
                  className={styles.mainInput}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <ParentInputField
                    handleUpdateCase={handleUpdateCase}
                    item={{
                      ...item,
                      refetchList:
                        refetchDropdownsListObj?.[item?.dropdownType] || null,
                    }}
                    refetchFieldHistory={refetchFieldHistory}
                    setTotalFormData={setTotalFormData}
                    totalFormData={totalFormData}
                  />
                </form>
              </ConditionalRenderer>

              <ConditionalRenderer condition={item?.isParent && item?.sections}>
                {item?.sections?.map((section, sectionIndex) => (
                  <div className={styles.singleSection}>
                    <div className={styles.readOnlyInput}>
                      <Input
                        prefix={
                          <PrefixInsideInput
                            label={translator(
                              `caseDetail.form.${section.sectionLabel}`,
                            )}
                          />
                        }
                        className={styles.readOnly}
                        value={section?.childs
                          ?.map((child) =>
                            totalFormData?.[child?.key]
                              ? totalFormData[child.key]
                              : "",
                          )
                          .filter(Boolean)
                          .join(", ")}
                      />
                    </div>

                    <div className={styles.childKeys}>
                      {section?.childs?.map((childItem, index) => (
                        <>
                          <InputWithLabel
                            key={index}
                            item={{
                              ...childItem,
                              dropdownList:
                                dropdownsListObj?.[childItem?.dropdownType] ||
                                null,
                              refetchList:
                                refetchDropdownsListObj?.[
                                  childItem?.dropdownType
                                ] || null,
                            }}
                            totalFormData={totalFormData}
                            setTotalFormData={setTotalFormData}
                            parentKey={item?.key}
                            autoFocus={index === 0 && sectionIndex === 0}
                            parentItem={item}
                          />
                        </>
                      ))}
                    </div>
                  </div>
                ))}
              </ConditionalRenderer>
              <ConditionalRenderer condition={item?.id !== 18}>
                <div className={styles.updateBtnContainer}>
                  <ConditionalRenderer
                    condition={caseStatusOpenOrClosed !== "closed"}
                  >
                    <button
                      onClick={handleUpdateData}
                      className={styles.updateBtn}
                      type="button"
                    >
                      Update
                    </button>
                  </ConditionalRenderer>
                </div>
              </ConditionalRenderer>
              <h3>{translator("caseDetail.latestUpdates")}</h3>
              <Spin spinning={caseHistoryLoading}>
                <div className={styles.tableContainer}>
                  <table className={styles.myTable}>
                    <thead>
                      <tr>
                        <th>Nr.</th>
                        <th>Aktualisiert von</th>
                        <th>Datum</th>
                        <th>Feld</th>
                        <th>Früher</th>
                        <th>Jetzt</th>
                      </tr>
                    </thead>
                    <tbody>
                      {caseHistory?.history?.map((row, index) => (
                        <tr key={row?.id?.toString()}>
                          <td>{index + 1}</td>
                          <td className={styles.updatedBy}>
                            <ConditionalRenderer
                              condition={row?.updatedByType === "MANUAL"}
                            >
                              <ManualIcon />
                            </ConditionalRenderer>{" "}
                            <ConditionalRenderer
                              condition={row?.updatedByType === "OCR"}
                            >
                              <AiIcon height={15} width={15} />
                            </ConditionalRenderer>{" "}
                            {row.updatedBy}
                          </td>
                          <td>
                            {row.updatedAt
                              ? moment(
                                  row.updatedAt,
                                  "YYYY-MM-DD HH:mm:ss",
                                ).format("DD-MM-YYYY HH:mm:ss")
                              : ""}
                          </td>
                          <td>
                            {translator(`caseDetail.form.${row.fieldName}`)}
                          </td>
                          <Tooltip title={row.previousValue}>
                            <td className={styles.previousValue}>
                              {row.previousValue}
                            </td>
                          </Tooltip>
                          <Tooltip title={row.currentValue}>
                            <td className={styles.previousValue}>
                              {row.currentValue}
                            </td>
                          </Tooltip>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Spin>
            </Collapse.Panel>
          </Collapse>
        </Spin>
      </div>
    </div>
  );
};

function FieldName({ entryName, reminderTrans, caseFormTrans }) {
  return (
    <div className={styles.modalTitle}>
      {reminderTrans.setReminder} - <span> {caseFormTrans[entryName]}</span>
    </div>
  );
}
